export const AutomationModuleTypes = {
    CHAT: "CHAT",
    CONTACT: "CONTACT",
    EMAIL: "EMAIL",
    TASK: "TASK",
    META_LEAD: "META_LEAD",
    AGENT: "AGENT",
    INVOICE: "INVOICE",
    WHATSAPP: "WHATSAPP",
    RESERVATION: "RESERVATION",
    CHATBOT: "CHATBOT",
};
export const AutomationEventTypes = {
    CHAT: {
        CREATED: "chat.created",
        CLOSED: "chat.closed",
    },
    CONTACT: {
        CREATED: "contact.created",
    },
    EMAIL: {
        RECEIVED: "email.received",
    },
    TASK: {
        CREATED: "task.created",
    },
    META_LEAD: {
        CREATED: "meta-lead.created",
    },
    AGENT: {
        CREATED: "agent.created",
    },
    INVOICE: {
        CREATED: "invoice.created",
    },
    WHATSAPP: {
        MESSAGE_RECEIVED: "whatsapp.message-received",
    },
    RESERVATION: {
        CREATED: "reservation.created",
    },
    CHATBOT: {
        MESSAGE_RECEIVED: "chatbot.message-received",
    },
};
